import React from 'react';
import PropTypes from 'prop-types';
import GenericTable from '../../../RegistrosDeUso/components/table/GenericTable';
import { estacionesColumnConfig } from './config/columnConfig';

const SEARCH_FIELDS = ['name', 'estado', 'version', 'registros_pendientes'];
const ROWS_PER_PAGE_OPTIONS = [10, 25, 50];

export default function TablaEstaciones({ data = [], loading = false }) {
  return (
    <GenericTable
      data={data}
      columns={estacionesColumnConfig}
      loading={loading}
      searchable={true}
      searchFields={SEARCH_FIELDS}
      title="Estaciones"
      emptyMessage="Sin estaciones disponibles"
      rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
    />
  );
}

TablaEstaciones.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    version: PropTypes.string,
    registros_pendientes: PropTypes.number,
    estado: PropTypes.string,
    ultima_Conexion: PropTypes.string,
    send_whatsapp: PropTypes.bool,
  })),
  loading: PropTypes.bool,
};
